import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const initRoutes = [{
    path: '/login',
    name: 'login',
    component: () =>
        import('@/views/Login.vue'),
},
{
    path: '/loginLyg',
    name: 'loginLyg',
    component: () =>
        import('@/views/loginLyg.vue'),
},
{
    path: '/loginHn',
    name: 'loginHn',
    component: () =>
        import('@/views/LoginHn.vue'),
},
{
    path: '/loginLy',
    name: 'loginLy',
    component: () =>
        import('@/views/LoginLy.vue'),
},
{
    path: '/loginGd',
    name: 'loginGd',
    component: () =>
        import('@/views/LoginGd.vue'),
},
{
    path: '/loginGx',
    name: 'loginGx',
    component: () =>
        import('@/views/LoginGx.vue'),
},
{
    path: '/register',
    name: 'register',
    component: () =>
        import('@/views/register/Register.vue'),
}, {
    path: '/registerInfo',
    name: 'registerInfo',
    component: () =>
        import('@/views/register/RegisterInfo.vue'),
}, {
    path: '/registerInfoRepeat',
    name: 'registerInfoRepeat',
    component: () =>
        import('@/views/register/RegisterInfoRepeat.vue'),
}, {
    path: '/reviewResult',
    name: 'reviewResult',
    component: () =>
        import('@/views/register/ReviewResult.vue'),
}, {
    path: '/bigScreen',
    name: 'bigScreen',
    component: () =>
        import('@/views/bigScreen.vue'),
}];

const routers = new Router({
    mode: process.env.NODE_ENV == 'production' ? 'history' : 'history',
    scrollBehavior: () => ({
        y: 0,
    }),
    routes: initRoutes,
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js